import React from 'react';
import PropTypes from 'prop-types';
import { cx } from 'emotion';

import { SingleFieldForm } from 'inside-out/components/shared/singleFieldForm';
import MagnifyingGlassIcon from 'inside-out/components/shared/icons/magnifyingGlassIcon';

import {
  treatmentServicesTypes,
  treatmentServicesDisciplines,
  treatmentServicesAgeRanges,
} from 'inside-out/managers/treatmentServicesManager';

import {
  filtersGroupStyle,
  typeFiltersGroupStyle,
  disciplineFiltersGroupStyle,
  filtersLabelStyle,
  ageFiltersGroupStyle,
  serviceFiltersGroupStyle,
} from './styles';


const SearchFilter = ({ value, onChange, onSubmit }) => (
  <SingleFieldForm
    onSubmit={ e => {
      e.preventDefault();
      onSubmit();
    } }
    onChange={ e => onChange(e.target.value) }
    value={ value }
    placeholderText="Search by Name, Suburb, Post code"
    buttonContent={ <MagnifyingGlassIcon /> }
    inputWidth={ 404 }/>
);
SearchFilter.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};


const CheckableInput = ({ type, name, value, label, checked, onChange }) => (
  <label className={ filtersLabelStyle }>
    <input
      value={ value }
      checked={ checked }
      type={ type }
      name={ name }
      onChange={ e => typeof onChange === 'function' && onChange({ value, checked: e.target.checked }) }/>
    <span className='checkmark'/>
    { label }
  </label>
);
CheckableInput.propTypes = {
  type: PropTypes.oneOf([ 'radio', 'checkbox' ]).isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  label: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
};


const treatmentServicesFields = treatmentServicesTypes
  .reduce((acc, k) => Object.assign(acc, { [k.value] : k.label }), {});
const TypesFilter = ({ onChange, value }) => (
  <div className={ cx(filtersGroupStyle, typeFiltersGroupStyle) }>
    <CheckableInput
      type='checkbox'
      name='serviceTypeAll'
      value=''
      label='All'
      checked={ !value }
      onChange={ () => onChange('') }/>
    <CheckboxGroup
      name='serviceType'
      fields={ treatmentServicesFields }
      checked={ value.split(',').filter(v => !!v) }
      onChange={ checked => onChange(checked.join(',')) }/>
  </div>
);
TypesFilter.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};


const DisciplineFilters = ({ onChange, value }) => (
  <div className={ cx(filtersGroupStyle, disciplineFiltersGroupStyle) }>
    <CheckboxGroup
      name='serviceDiscipline'
      fields={ treatmentServicesDisciplines }
      checked={ value.split(',').filter(v => !!v) }
      onChange={ checked => onChange(checked.join(',')) }/>
  </div>
);
DisciplineFilters.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};


const AgeRangeFilters = ({ onChange, value }) => (
  <div>
    <h3>Age Range</h3>
    <div className={ cx(filtersGroupStyle, ageFiltersGroupStyle) }>
      <CheckboxGroup
        name='ageRange'
        fields={ treatmentServicesAgeRanges }
        checked={ value.split(',').filter(v => !!v) }
        onChange={ checked => onChange(checked.join(',')) }/>
    </div>
  </div>
);
AgeRangeFilters.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

const tretmentServicesServiceTypes = {
  public: 'Public service',
  private: 'Private service',
};
const ServiceFilters = ({ onChange, value }) => (
  <div>
    <h3>Service</h3>
    <div className={ cx(filtersGroupStyle, serviceFiltersGroupStyle) }>
      <CheckboxGroup
        name='serviceType'
        fields={ tretmentServicesServiceTypes }
        checked={ value.split(',').filter(v => !!v) }
        onChange={ checked => onChange(checked.join(',')) }/>
    </div>
  </div>
);
ServiceFilters.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};


class CheckboxGroup extends React.PureComponent {
  static propTypes = {
    name: PropTypes.string.isRequired,
    fields: PropTypes.object,
    onChange: PropTypes.func,
    checked: PropTypes.arrayOf(PropTypes.string),
  }

  onCheckboxChange = (changed) => {
    const { checked = [], onChange } = this.props;
    if (typeof onChange !== 'function') return;
    if (changed.checked) {
      if (!checked.includes(changed.value)) {
        onChange([ ...checked, changed.value ]);
      }
    } else {
      if (checked.includes(changed.value)) {
        onChange(checked.filter(v => v !== changed.value));
      }
    }
  }

  render() {
    const { name, fields, checked = [] } = this.props;
    return (
      <React.Fragment>
        { Object.keys(fields).map(field => (
          <CheckableInput
            key={ field }
            type='checkbox'
            name={ name }
            value={ field }
            label={ fields[field] }
            checked={ checked.includes(field) }
            onChange={ this.onCheckboxChange }/>
        )) }
      </React.Fragment>
    );
  }
}


export {
  SearchFilter,
  TypesFilter,
  DisciplineFilters,
  AgeRangeFilters,
  ServiceFilters,
};



// WEBPACK FOOTER //
// ./src/components/treatment-services/filters/component.js